import { useEvent } from 'react-use-event-hook'
import { baseScanUrl, openSeaAssetUrl } from '@components/Web3/utils'
import { IconButton, Stack } from '@ui'

export const TownContractInfoButtons = (props: {
    address: string | undefined
    chainId: number | undefined
}) => {
    const { address, chainId } = props

    const onAddressClick = useEvent(() => {
        if (!address || !chainId) {
            return
        }
        window.open(`${baseScanUrl(chainId)}/address/${address}`, '_blank', 'noopener,noreferrer')
    })

    const onOpenSeaClick = useEvent(() => {
        if (!address || !chainId) {
            return
        }
        window.open(`${openSeaAssetUrl(chainId, address)}`, '_blank', 'noopener,noreferrer')
    })

    if (!address || !chainId) {
        return null
    }

    return (
        <Stack
            display="flex"
            flexDirection="row"
            gap="sm"
            alignItems="center"
            paddingLeft="sm"
            marginTop="xs"
        >
            <IconButton
                color="gray2"
                hoverColor="default"
                icon="etherscan"
                size="square_md"
                onClick={onAddressClick}
            />
            <IconButton
                color="gray2"
                hoverColor="default"
                icon="openSeaPlain"
                size="square_md"
                onClick={onOpenSeaClick}
            />
        </Stack>
    )
}
